module.exports = __webpack_public_path__ + "static/media/works-huang.4838f32c.jpg";